import React from "react"
import { Link } from "gatsby"
import {
  IconChevronRight,
  RegBody,
  SemiBdTitle3,
  SemiBdTitle4,
  SemiBdTitle6,
} from "@sr/gatsby-theme-ui"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

const honeywell =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550478/pages/product/logos/Honeywell_oil6lf_asudhp.svg"
const kwikset =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550477/pages/product/logos/Kwikset_tfh7xs_o0fqyt.svg"
const ring =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550480/pages/product/logos/ring_ipddcq_qp74if.svg"
const salto =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550480/pages/product/logos/Salto_q5kkef_nvmmls.svg"
const anyoneHome =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1715026444/pages/home-03-16-2023/logos/AnyoneHome_Logo_dmex5k.svg"
const resideo =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1691774565/pages/product/logos/Resideo_Logo_zsr8k8.svg"
const engrain =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550481/pages/product/logos/engrain_fpwfla_dfh7o7.svg"
const entrata =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550477/pages/product/logos/entrata_n0pih9_h0jooe.svg"
const realpage =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550477/pages/product/logos/realpage_iwxis4_llpbcx.svg"
const yardi =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550479/pages/product/logos/yardi_n77xdw_ebzgnd.svg"
const knock =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550477/pages/product/logos/frame_jn4jfq_npbvqp.svg"
const funnel =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550482/pages/product/logos/funnel_ghb0r2_gdbyvj.svg"
const resman =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550480/pages/product/logos/resman_mjyaro_kppo21.svg"
const yale =
  "https://res.cloudinary.com/smartrent-com/image/upload/v1685550477/pages/product/logos/yale_do9icv_orcp4u.svg"

const iconArray = [
  entrata,
  resideo,
  anyoneHome,
  realpage,
  knock,
  honeywell,
  funnel,
  ring,
  yardi,
  kwikset,
  salto,
  yale,
  resman,
  engrain,
]

export interface HardwareIntegrationsPropsShape {
  bgColor?: string
  modifiedPadding?: boolean
}

const HardwareIntegrations = ({
  bgColor = "var(--color-white)",
  modifiedPadding = false,
}: HardwareIntegrationsPropsShape) => {
  return (
    <HardwareIntegrationsStyled
      bgColor={bgColor}
      modifiedPadding={modifiedPadding}
    >
      <SemiBdTitle6 className="hardware-integrations__label">
        Integrations
      </SemiBdTitle6>
      <SemiBdTitle3 className="hardware-integrations__header">
        More compatibility, more integrations
      </SemiBdTitle3>
      <RegBody className="hardware-integrations__body">
        SmartRent has more seamless integrations than any other multifamily
        technology brand. That means more convenience and features, whether
        you’re building smart communities from the ground up or retrofitting
        older technology.
      </RegBody>
      <div className="hardware-integrations__icons-container">
        {iconArray.map((icon, i: number) => {
          return (
            <div className="hardware-integrations__icon-container" key={i}>
              <img src={icon} className="hardware-integrations__icon" />
            </div>
          )
        })}
      </div>
      <div className="hardware-integrations__link-container">
        <Link
          to="/integrations-partnerships/"
          className="hardware-integrations__link"
        >
          <div className="hardware-integrations__link-icon-container">
            <IconChevronRight color="var(--color-primary)" />
          </div>
          <SemiBdTitle4 className="hardware-integrations__link-text">
            View all integrations
          </SemiBdTitle4>
        </Link>
      </div>
    </HardwareIntegrationsStyled>
  )
}

export default HardwareIntegrations

interface HardwareIntegrationsSC {
  bgColor: string
  modifiedPadding: boolean
}

const HardwareIntegrationsStyled = styled.div<HardwareIntegrationsSC>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: ${({ bgColor }) => bgColor};
  padding: ${({ modifiedPadding }) =>
    modifiedPadding
      ? `${rem(8)} ${rem(16)} ${rem(64)}`
      : `${rem(40)} ${rem(16)} ${rem(64)}`};

  @media ${media.midUp} {
    padding: ${({ modifiedPadding }) =>
      modifiedPadding ? `${rem(16)} 0 ${rem(72)}` : `${rem(64)} 0 ${rem(72)}`};
  }

  @media ${media.stMidUp} {
    padding: ${({ modifiedPadding }) =>
      modifiedPadding ? `0 0 ${rem(72)}` : `${rem(96)} 0 ${rem(104)}`};
  }

  .hardware-integrations__label {
    color: var(--color-primary);
    font-size: ${rem(16)};
    line-height: ${rem(24)};

    @media ${media.midUp} {
      font-size: ${rem(20)};
      line-height: ${rem(24)};
    }
  }

  .hardware-integrations__header {
    padding-top: ${rem(8)};
    font-size: ${rem(32)};
    line-height: ${rem(40)};

    @media ${media.midUp} {
      max-width: ${rem(462)};
      font-size: ${rem(40)};
      line-height: ${rem(48)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(435)};
    }
  }

  .hardware-integrations__body {
    max-width: ${rem(342)};
    padding-top: ${rem(16)};

    @media ${media.midUp} {
      max-width: ${rem(462)};
    }

    @media ${media.stMidUp} {
      padding-top: ${rem(16)};
      max-width: ${rem(649)};
    }
  }
  .hardware-integrations__icons-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    max-width: ${rem(336)};
    gap: ${rem(48)};
    padding-top: ${rem(56)};

    @media ${media.midUp} {
      max-width: ${rem(364)};
      gap: ${rem(62)};
      padding-top: ${rem(64)};
    }

    @media ${media.stMidUp} {
      max-width: ${rem(950)};
      gap: ${rem(56)} ${rem(64)};
      padding-top: ${rem(56)};
    }

    .hardware-integrations__icon-container {
      width: ${rem(80)};
      height: ${rem(80)};
      object-fit: contain;
      border: 1px solid var(--color-gray200);
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${rem(10)} ${rem(8)};
      background: var(--color-white);
    }
  }

  .hardware-integrations__link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: ${rem(48)};

    @media ${media.midUp} {
      padding-top: ${rem(56)};
    }

    @media ${media.stMidUp} {
      padding-top: ${rem(56)};
    }

    .hardware-integrations__link {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: ${rem(8)};
      color: var(--color-primary);
      text-decoration: none;
    }

    .hardware-integrations__link-icon-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: ${rem(32)};
      height: ${rem(32)};
      border: 1px solid var(--color-primary);
      border-radius: ${rem(32)};
    }

    .hardware-integrations__link-text {
      @media ${media.stMidUp} {
        font-size: ${rem(20)};
      }
    }
  }
`
